import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		meta: {
			title: 'Home | Fungo Holdings Inc.',
			description: 'Fungo Holdings Inc. is a global leader in investing and developing cutting-edge mobile internet and AI technologies, driving digital transformation worldwide.',
		},
	},
	{
		path: '/portfolio',
		name: 'portfolio',
		component: () => import(/* webpackChunkName: "portfolio" */ '../pages/portfolio.vue'),
		meta: {
			title: 'Portfolio | Fungo Holdings Inc.',
			description: 'Explore our diverse portfolio of innovative mobile internet and AI investments, driving global digital transformation.',
		},
	},
	{
		path: '/investment-criteria',
		name: 'investment',
		component: () => import(/* webpackChunkName: "investment" */ '../pages/investment.vue'),
		meta: {
			title: 'Investment Criteria | Fungo Holdings Inc.',
			description: 'Learn about our strategic investment criteria focused on mobile internet and AI solutions for sustainable growth.',
		},
	},
	{
		path: '/about-us',
		name: 'about',
		component: () => import(/* webpackChunkName: "about" */ '../pages/about.vue'),
		meta: {
			title: 'About Us | Fungo Holdings Inc.',
			description: 'Discover Fungo Holdings Inc., a leader in mobile internet and AI investments, operating across 178+ countries since 2018.',
		},
	},
	{
		path: '/careers',
		name: 'careers',
		component: () => import(/* webpackChunkName: "careers" */ '../pages/careers.vue'),
		meta: {
			title: 'Careers | Fungo Holdings Inc.',
			description: 'Join our team at Fungo Holdings Inc. and be part of a global leader in mobile internet and AI innovation.',
		},
	},
	{
		path: '/contact-us',
		name: 'contact',
		component: () => import(/* webpackChunkName: "contact" */ '../pages/contact.vue'),
		meta: {
			title: 'Contact Us | Fungo Holdings Inc.',
			description: 'Get in touch with Fungo Holdings Inc. for inquiries about our investments and partnerships in mobile internet and AI.',
		},
	},
	{
		path: '/terms-of-service',
		name: 'terms',
		component: () => import(/* webpackChunkName: "terms" */ '../pages/terms.vue'),
		meta: {
			title: 'Terms of Service | Fungo Holdings Inc.',
			description: "Review the terms of service for using Fungo Holdings Inc.'s website and services.",
		},
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import(/* webpackChunkName: "privacy" */ '../pages/privacy.vue'),
		meta: {
			title: 'Privacy Policy | Fungo Holdings Inc.',
			description: 'Understand how Fungo Holdings Inc. protects your privacy and manages your data in compliance with global standards.',
		},
	},
	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
